import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { GENZ_SERIES } from '../components/genz/genzContent';
import { GenZOverview } from '../components/genz/GenZOverview';
import { LessonCard } from '../components/genz/LessonCard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GenZSeries() {
  const [lessons, setLessons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/genz/lessons`)
      .then(({ data }) => setLessons(data))
      .catch((err) => console.error('Failed to load lessons:', err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-background-primary">
      <SEO
        title={`${GENZ_SERIES.title} | RestoreMyWord.net`}
        description={GENZ_SERIES.intro}
        url="https://restoremyword.net/gen-z"
        image={GENZ_SERIES.thumbnail}
      />
      <Navbar />
      <section className="bg-brand-primary py-16 md:py-24" data-testid="genz-series-header">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <img src={GENZ_SERIES.thumbnail} alt={`${GENZ_SERIES.title} series`} className="lg:col-span-4 w-full max-w-sm mx-auto rounded shadow-2xl" data-testid="genz-series-page-thumbnail" />
          <div className="lg:col-span-8">
            <p className="text-xs font-semibold tracking-[0.3em] uppercase text-brand-accent mb-4">Bible Teaching Series</p>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-white leading-[1.05] mb-4" data-testid="genz-series-title">
              {GENZ_SERIES.title}
            </h1>
            <p className="font-body text-base md:text-lg font-medium text-brand-accent mb-6">{GENZ_SERIES.subtitle}</p>
            <GenZOverview />
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24" data-testid="genz-lessons-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-brand-primary mb-10">Lessons</h2>
          {loading ? (
            <p className="font-body text-slate-600" data-testid="genz-lessons-loading">Loading lessons...</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="genz-lessons-grid">
              {lessons.map((lesson) => <LessonCard key={lesson.id} lesson={lesson} />)}
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}
